import React, { useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";
import { Building2, ArrowRightLeft, Loader2, X } from "lucide-react";

/** KI-Hinweis: Beleg gehört vermutlich zu einer anderen Firma des Inhabers – Übertragung mit einem Klick. */
export function InboxCompanySuggestion({ companyId, item, onDone }) {
  const [busy, setBusy] = useState(false);
  const s = item.company_suggestion;
  if (!s || s.dismissed || !s.company_id) return null;

  const move = async () => {
    setBusy(true);
    try {
      const r = await apiClient.post(`/companies/${companyId}/inbox/${item.id}/move-company`, { target_company_id: s.company_id });
      toast.success(`Beleg an ${r.data.target_company_name} übertragen`);
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Übertragung fehlgeschlagen"); } finally { setBusy(false); }
  };

  const dismiss = async () => {
    setBusy(true);
    try {
      await apiClient.post(`/companies/${companyId}/inbox/${item.id}/company-suggestion/dismiss`);
      onDone?.();
    } catch { toast.error("Konnte nicht ausblenden"); } finally { setBusy(false); }
  };

  const pct = Math.round((s.confidence || 0) * 100);
  return (
    <div className="mt-2 rounded-md border border-violet-200 bg-violet-50/70 px-3 py-2 text-xs" data-testid={`inbox-company-suggestion-${item.id}`}>
      <div className="flex flex-wrap items-center gap-2">
        <Building2 className="h-4 w-4 text-violet-700" />
        <span className="font-semibold text-violet-900">Gehört dieser Beleg zu «{s.company_name}»?</span>
        <span className="text-violet-800" data-testid={`inbox-company-suggestion-reason-${item.id}`}>{s.reason} · {pct} % sicher</span>
        <span className="ml-auto inline-flex items-center gap-1.5">
          <button type="button" onClick={move} disabled={busy}
            className="inline-flex items-center gap-1 rounded bg-violet-700 px-2 py-1 font-medium text-white hover:bg-violet-800 disabled:opacity-50"
            data-testid={`inbox-company-suggestion-move-${item.id}`}>
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <ArrowRightLeft className="h-3 w-3" />} Zu {s.company_name} übertragen
          </button>
          <button type="button" onClick={dismiss} disabled={busy}
            className="inline-flex items-center gap-1 rounded border border-violet-300 bg-white px-2 py-1 text-violet-800 hover:bg-violet-100 disabled:opacity-50"
            data-testid={`inbox-company-suggestion-dismiss-${item.id}`}>
            <X className="h-3 w-3" /> Nein, hier behalten
          </button>
        </span>
      </div>
    </div>
  );
}
